'use client';

import { datadogLogs } from '@datadog/browser-logs';
import { datadogRum } from '@datadog/browser-rum';
import { useEffect } from 'react';
import { setDatadogInitialized } from '@/libs/DatadogTransport';
import logger from '@/libs/Logger';

export function DatadogInit() {
  useEffect(() => {
    if (
      typeof window !== 'undefined' &&
      !datadogRum.getInitConfiguration() &&
      process.env.NEXT_PUBLIC_DATADOG_APPLICATION_ID &&
      process.env.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN
    ) {
      // Get version - this is set in next.config.ts to ensure consistency
      // with source map uploads
      const version = process.env.NEXT_PUBLIC_APP_VERSION ?? '1.0.2'; // Fallback to package.json version

      // Initialize RUM
      datadogRum.init({
        applicationId: process.env.NEXT_PUBLIC_DATADOG_APPLICATION_ID,
        clientToken: process.env.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN,
        site: 'us3.datadoghq.com',
        service: 'resident-portal-session-monitoring',
        env: 'prod',
        version, // Add version for source map matching
        sessionSampleRate: 100,
        sessionReplaySampleRate: 100,
        defaultPrivacyLevel: 'mask-user-input',
      });

      // Initialize Browser Logs
      datadogLogs.init({
        clientToken: process.env.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN,
        site: 'us3.datadoghq.com',
        service: 'resident-portal',
        env: 'prod',
        version, // Add version for consistency
        // // Forward console errors to Datadog
        // forwardErrorsToLogs: true,
        // // Forward console logs based on log level
        // forwardConsoleLogs: ['error', 'warn'],
        // Sample rate for logs
        sessionSampleRate: 100,
      });

      // Mark Datadog as initialized
      setDatadogInitialized();

      // Now we can safely use the logger for future logs
      // The first log will create the Datadog logger instance
      logger.info(
        `Datadog RUM and Logs initialized successfully. Version: ${version}`
      );
    }
  }, []);

  return null;
}
